import { createSlice } from "@reduxjs/toolkit";

export const userSlice = createSlice({
	name: "user",
	// estado inicial definido en la parte superior line:3
	initialState: {},
	// todas las acciones que puden modificar el store
	reducers: {
		changename: (state, { payload }) => {},
	},
});

export const { changename } = userSlice.actions;
